<div
  role="dialog"
  [class]="'esn-tour-callout esn-tour-callout--pointer-' + pointer()"
  [attr.aria-labelledby]="heading() ? titleId : null"
  [attr.aria-describedby]="body() ? bodyId : null"
  (keydown.escape)="skip.emit()"
>
  @if (pointer() !== 'none') {
    <span class="esn-tour-callout__arrow" aria-hidden="true"></span>
  }

  <div class="esn-tour-callout__progress">
    <span class="esn-tour-callout__sr">{{ srProgress() }}</span>
    @for (dot of dots(); track $index) {
      <span [class]="'esn-tour-callout__dot esn-tour-callout__dot--' + dot" aria-hidden="true"></span>
    }
  </div>

  <div class="esn-tour-callout__copy">
    <h2 class="esn-tour-callout__title" [id]="titleId">{{ heading() }}</h2>
    <p class="esn-tour-callout__body" [id]="bodyId">{{ body() }}</p>
    <ng-content />
  </div>

  <div class="esn-tour-callout__footer">
    @if (skipLabel()) {
      <esn-button variant="link" (clicked)="skip.emit()">{{ skipLabel() }}</esn-button>
    } @else {
      <span></span>
    }
    <div class="esn-tour-callout__actions">
      @if (showBack()) {
        <esn-button variant="outline" (clicked)="back.emit()">{{ backLabel() }}</esn-button>
      }
      <esn-button variant="primary" [leadingIcon]="primaryIcon()" (clicked)="primary()">{{ primaryLabel() }}</esn-button>
    </div>
  </div>
</div>
